import React from "react";

import Checkbox from "Components/Form/Checkbox";

import { SearchItemContainer, SearchItemLabel } from "./styles";

export interface SearchItem {
  value: string;
  label: string;
  checked: boolean;
}
interface SearchItemProps {
  item: SearchItem;
  handleChange: (id: string) => void;
  disabled?: boolean;
}

export const SearchItemIput = ({ item, handleChange, disabled }: SearchItemProps) => {
  return (
    <SearchItemContainer>
      <Checkbox
        checked={item.checked}
        onChange={() => handleChange(item.value)}
        disabled={disabled}
      />
      <SearchItemLabel>{item.label}</SearchItemLabel>
    </SearchItemContainer>
  );
};
